export const TriggerIcon = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="">
            {children}
        </div>
    )
};